<template>
  <v-container fluid>
    <list-editor
      :column-keys="columnKeys"
      :items="items"
      :loading="loading"
      :showSearchBar="true"
      :showSearchDate="true"
      :isFinanceCreditList="true"
      :searchPlaceHolder="searchPlaceHolder"
      :totalItems="getTotalItems"
      :startDate="startDate"
      :endDate="endDate"
      :getSearchKeys="searchKeys"
      :show-select="false"
      @editData="edit"
      @searchData="searchData"
      @printData="printData"
      @pageView="pageView"
      @uploadData="uploadData"
      @uploadFileData="uploadFileData"
      @changePage="changePage"
      @handleLoadData="handleLoadData"
    ></list-editor>

    <!--其他工具-彈窗-->
    <FinanceCreditDialog
      :item="editedItem"
      :row-item="rowItemInfo"
      :visible="toolDialog.visible"
      :platform="0"
      :isUpdateAction="true"
      @showEvent="toolEvent"
      @closeEvent="toolDialog.visible = false"
      @confirmEvent="toolDialog.visible = false"
    ></FinanceCreditDialog>

    <!--彈出視窗-->
    <alert-view
      :visible="messageDialog.visible"
      :title="messageDialog.title"
      :content="messageDialog.text"
      :isHtmlContent="true"
      :showCancel="messageDialog.showCancelButton"
      @cancelEvent="messageDialog.cancel"
      @confirmEvent="messageDialog.confirm"
    ></alert-view>

    <!--圖檔管理-->
    <v-dialog
      title="圖片上傳"
      v-model="uploadDialog"
      :width="isMobile ? '90%' : '60%'"
    >
      <v-card>
        <v-card-title>
          <h3>圖片上傳</h3>
        </v-card-title>
        <v-card-text>
          <upload-view
            :item-detail="editedItem"
            :uploadType="uploadType"
            :is-official="false"
            :show-upload-button="true"
            @onFinishUpload="onFinishUpload"
          ></upload-view>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--檔案管理-->
    <v-dialog v-model="uploadFileDialog" :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-title>
          <h3>PDF上傳</h3>
        </v-card-title>
        <v-card-text>
          <upload-file-tool
            :item-detail="editedItem"
            :uploadType="uploadFileType"
            :is-official="false"
            @onFinishUpload="onFinishFileUpload"
          ></upload-file-tool>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import MobileDetect from "mobile-detect";
import LineShare from "line-share";
import { mapActions, mapGetters } from "vuex";

import { getNow, getFinanceUrl, customFormatDate } from "../utils/tool";
import ListEditor from "../../components/ListEditor";
import dateTimeTool from "../../components/dateTimeTool";
import UploadView from "../../components/UploadView";
import UploadFileTool from "../../components/uploadFileTool";
import FinanceOfficialView from "../../components/FinanceOfficialView";

import LaonhfcModel from "../../models/LaonhfcModel";
import PaymentInfoModel from "../../models/PaymentInfoModel";
import CaseInsureModel from "../../models/CaseInsureModel";
import common from "@/mixins/common";
import ApplicationModel from "../../models/ApplicationModel";
import FinanceCreditDialog from "../../components/FinanceCreditDialog";
import AlertView from "@/components/AlertView";

const md = new MobileDetect(window.navigator.userAgent);
const priceData = require("../../assets/credit_price");
const cityList = require("../../assets/taiwan_city");

export default {
  name: "InsureAgentList",
  components: {
    FinanceCreditDialog,
    ListEditor,
    dateTimeTool,
    UploadView,
    UploadFileTool,
    FinanceOfficialView,
    AlertView
  },
  data() {
    return {
      financeCountInfo: {
        today: 0,
        month: 0
      },
      vendor: {
        contactName: "",
        contactPhone: ""
      },
      pageIndex: 1,
      limit: 5,
      totalItems: 0,
      startDate: "",
      endDate: "",
      searchKey: "",
      searchValue: "",
      searchPlaceHolder: "搜尋身分證、姓名、申辦人員",
      uploadDialog: false,
      uploadType: "add",
      uploadFileDialog: false,
      entrepreneurDialog: {
        visible: false,
        category: 0,
        confirm: () => {},
        cancel: () => {}
      },
      loanhfcDialog: {
        visible: false,
        category: 0,
        confirm: () => {},
        cancel: () => {}
      },
      caDialog: {
        visible: false,
        category: 0,
        confirm: () => {},
        cancel: () => {}
      },
      applicationDialog: {
        visible: false,
        view: () => {},
        form: () => {}
      },
      uploadFileType: "add",
      newMortgageItem: null,
      showCA20: false,
      creditPriceData: priceData,
      cityData: cityList,
      cityList: [],
      areaList: {},
      loading: false,
      fetchCountLoading: false,
      valid: true,
      dialog: false,
      editedIndex: -1,
      editedItem: new ApplicationModel(),
      defaultItem: {
        caseType: 0, // 0優加 1優質 2一般 3借新還舊 4他行代償 5萬物代
        caseId: Math.uuidFast(),
        displayId: "",
        caseName: "機車原融",
        applyDate: {
          year: "",
          month: "",
          day: "",
          isRepublic: false,
          disabled: false
        },
        approvedDate: {
          year: "",
          month: "",
          day: "",
          isRepublic: false,
          disabled: false
        },
        name: "",
        memberId: "",
        birthday: {
          year: "",
          month: "",
          day: "",
          isRepublic: true
        },
        cellphone: "",
        city: "",
        area: "",
        address: "",
        creditPrice: 0, // 貸款金額
        installmentsNumber: 12,
        creditPriceMonth: 0,
        totalCreditPrice: 0, // 總貸金額
        caseStatus: 0, // 0進件中 1婉拒 2待捕
        parentAgent: null,
        confirmAgent: null,
        createDate: getNow(),
        comment: "",
        agentId: "",
        confirmAgentId: ""
      },
      toolDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {}
      },
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancelButton: false,
        confirm: () => {},
        cancel: () => {}
      },
      pageDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {}
      },
      search: {
        keyword: ""
      },
      items: [],
      caseId: "",
      productName: "",
      carId: "",
      bankName: "",
      bankSubName: "",
      bankAccount: "",
      beforeBankName: "",
      beforeName: "",
      beforeBankSubName: "",
      beforeBankAccount: "",
      contractAddress: "",
      syncToken: "",
      itemInfo: {
        vendor: "",
        name: "",
        publicYear: "",
        publicMonth: "",
        engineId: "",
        cc: "",
        signImage: ""
      },
      timeoutID: null,
      rowItemInfo: {}
    };
  },
  created() {
    this.cityData.taiwan.forEach(city => {
      this.cityList.push(city.city);
      this.areaList[city.city] = city.area;
    });

    const now = new Date();
    this.defaultItem.applyDate.year = `${now.getFullYear()}`;
    this.defaultItem.applyDate.month = `${
      now.getMonth() + 1 < 10 ? `0${now.getMonth() + 1}` : now.getMonth() + 1
    }`;
    this.defaultItem.applyDate.day = `${
      now.getDate() + 1 < 10 ? `0${now.getDate() + 1}` : now.getDate() + 1
    }`;

    this.fetchAgentList().then(() => {
      this.editedItem.agentId = this.getUserInfo.agentId;
      // this.changeAgent();
    });
    this.loadData();
    this.setDefualtDate();
    this.loadFinanceCountInfo();
  },
  mixins: [common],
  watch: {
    $route(to, from) {
      if (to.path.indexOf("FinanceCreditList") > -1) {
        this.timeoutID = setInterval(() => {
          this.loadData();
          console.log(`5分鐘刷新 ${getNow()}`);
        }, 5 * 60 * 1000);
      } else {
        if (this.timeoutID) {
          clearInterval(this.timeoutID);
        }
      }
    }
  },
  computed: {
    ...mapGetters(["getUserInfo", "getAgentList"]),
    hasBeforeBank() {
      return this.editedItem.vendor && this.editedItem.vendor.productId === "2";
    },
    getTotalItems() {
      return this.totalItems;
    },
    formTitle() {
      return this.editedIndex === -1 ? "新增" : "編輯";
    },
    columnKeys() {
      let list = [
        {
          value: "tools",
          text: "檢視",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false
        },
        {
          value: "print",
          text: "其他工具",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false
        },
        {
          value: "displayId",
          text: "案件編號",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true
        },
        {
          value: "name",
          text: "申辦人",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true
        },
        {
          value: "memberId",
          text: "身分證字號",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true
        },
        {
          value: "vendorName",
          text: "經辦人",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true
        },
        {
          value: "saveDate",
          text: "儲存日期",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true
        },
        {
          value: "caseStatus",
          text: "案件狀態",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true
        },
        {
          value: "category",
          text: "專案類型",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true
        },
        {
          value: "caseType",
          text: "顧客評分",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true
        },
        {
          value: "productName",
          text: "專案名稱",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true
        },
        {
          value: "applyDisplayDate",
          text: "申請日期",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true
        },
        {
          value: "creditPrice",
          text: "貸款金額",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true
        },
        {
          value: "installmentsNumber",
          text: "總期數",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true
        },
        {
          value: "creditPriceMonth",
          text: "月付金額",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true
        },
        {
          value: "createDate",
          text: "建立時間",
          sortable: true,
          required: false,
          disabled: true,
          isShow: true,
          isEdit: true
        },
        {
          value: "bonus",
          text: "佣金",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: true
        },
        {
          value: "settingPrice",
          text: "設定費",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: true
        },
        {
          value: "comment",
          text: "備註",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: true
        }
      ];
      if (this.isAdmin) {
        return list;
      } else if (this.getUserInfo.enableLoanhfc === true) {
        return list.filter(m => m.value !== "delete" && m.value !== "bonus");
      }
      return list.filter(
        m =>
          m.value !== "changeCase" &&
          m.value !== "delete" &&
          m.value !== "bonus"
      );
    },
    searchKeys() {
      return [
        { key: "name", value: "姓名" },
        { key: "memberId", value: "身分證字號" },
        { key: "vendorName", value: "經辦人姓名" },
        { key: "displayId", value: "案件編號" }
      ];
    },
    getCreditPriceList() {
      const list = [];
      for (let i = 40000; i <= 200000; i += 10000) {
        list.push(i);
      }
      return list;
    },
    getInstallmentsNumberList() {
      return [12, 15, 18, 20, 24];
    },
    dialogKeys() {
      return this.columnKeys.filter(m => m.value !== "tools");
    },
    isAdmin() {
      return this.getUserInfo.authority === "admin";
    },
    getCaseType() {
      // //0優加 1優質 2一般 3借新還舊 4他行代償 5萬物代
      return [
        { key: 0, value: "優加" },
        { key: 1, value: "優質" },
        { key: 2, value: "一般" },
        { key: 3, value: "借新還舊" },
        { key: 4, value: "他行代償" },
        { key: 5, value: "萬物代" }
      ];
    }
  },
  methods: {
    ...mapActions([
      "getFinanceCreditNewList",
      "getFinanceCreditList",
      "loginAgentService",
      "fetchAgentList",
      "fetchCreditProductInfo",
      "getFinanceCountInfo"
    ]),

    setDefualtDate() {
      let todayDate = new Date();
      todayDate.setMonth(todayDate.getMonth() - 1);
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth, thisDay] = currentDate.split("-");
      this.startDate = `${thisYear}-${thisMonth}-01`;

      let futureDate = new Date();
      // 将当前月份加1，下移到下个月
      futureDate.setMonth(futureDate.getMonth() + 1);
      // 再获取天数即取上个月的最后一天的天数
      futureDate.setDate(0);
      let days = futureDate.getDate();

      let endDate = futureDate.toISOString().substr(0, 10);
      const [futureYear, futureMonth, futureDay] = endDate.split("-");

      this.endDate = `${futureYear}-${futureMonth}-${days}`;
    },
    changeAgent() {
      const find = this.getAgentList.find(
        agent => agent.agentId === this.editedItem.agentId
      );
      if (find) {
        if (find.authority === "admin") {
          this.$set(this.editedItem, "parentAgent", {
            agentId: find.agentId,
            agentNumber: find.agentNumber ? find.agentNumber : find.agentId,
            displayName: find.displayName ? find.displayName : find.email,
            parentAgent: find.parentAgent ? find.parentAgent : find.agentId,
            salesName: find.salesName ? find.salesName : find.email,
            cellphone: find.cellphone ? find.cellphone : ""
          });
        } else {
          this.$set(this.editedItem, "parentAgent", {
            agentId: find.agentId,
            agentNumber: find.agentNumber,
            displayName: find.displayName,
            parentAgent: find.parentAgent,
            salesName: find.salesName,
            cellphone: find.cellphone
          });
        }
      }
    },
    changePage(page) {
      this.pageIndex = page.page;
      this.limit = page.rowsPerPage;
      this.loadData();
    },
    async loadData() {
      this.loading = true;
      const loginResult = await this.loginAgentService({
        email: this.getUserInfo.email
      });
      this.syncToken = loginResult.data.data.token;
      let searchQuery = [{ key:'insureAgent', value:this.getUserInfo.agentId }];
      if(this.searchValue) {
        searchQuery.push({ key:'name', value:this.searchValue})
      }
      // console.log(`loginResult.data == ${JSON.stringify(loginResult.data)}`);
      const results = await this.getFinanceCreditNewList({
        token: this.syncToken,
        agentId: "",
        email: this.getUserInfo.email,
        searchQuery: searchQuery,
        startDate: `${this.startDate} 00:00:00`,
        endDate: `${this.endDate} 23:59:59`,
        pageIndex: this.pageIndex,
        limit: this.limit
      });
      this.items = results.data.data.list;
      this.totalItems = results.data.data.header.totalCount;
      this.loading = false;
      console.log(`items === ${JSON.stringify(this.items)}`);
    },
    async importData(data) {
      this.loading = true;
      let title = "錯誤";
      let message = "";
      try {
        const res = await this.saveMultiResult({
          list: data
        });
        const saveResult = res.data;
        this.loading = false;
        if (saveResult) {
          if (saveResult.statusCode === 0) {
            title = "成功";
          }
          console.log(JSON.stringify(saveResult));
          message = saveResult.message;
        }
      } catch (e) {
        this.loading = false;
        message = `發生錯誤 ${e}`;
      }

      this.showMessageDialog(
        title,
        message,
        true,
        () => {},
        () => {}
      );
    },
    view(item) {
      const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: this.editedItem.category,
            isPrint: false
          }
      });
      window.open(routeData.href, "_blank");
    },
    edit(item) {
      console.log(`edit == ${JSON.stringify(item)}`);
      const isPrint = item.category === 2 ? true : false
      const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: item.caseId,
            caseCategory: item.category,
            isPrint: isPrint,
            platform:item.platform
          }
      });
      window.open(routeData.href, "_blank");
      // if (item.category === 3) {
      //   this.applicationDialog.visible = true;
      //   this.applicationDialog.view = () => {
      //     this.applicationDialog.visible = false;
      //     this.gotoCredit(item, 0);
      //   };
      //   this.applicationDialog.form = () => {
      //     this.applicationDialog.visible = false;
      //     this.gotoCredit(item, item.category);
      //   };
      // } else {
      //   this.gotoCredit(item, item.category);
      // }
    },
    gotoCredit(item, category) {
      this.editedIndex = 0;
      if (category === 2 && !item.platform) {
        item.platform = 0;
      }
      const query = {
        caseCategory: category,
        editIndex: 0,
        caseId: item.caseId,
        enable: true,
        agentId: item.agentId,
        platform: item.platform, //0裕富 3高踞
        isFinance: 1
      };
      console.log(` gotoCredit === ${JSON.stringify(query)}`);
      // this.$router.push({ path: '/EditCreditProduct', query });
      let routeData = this.$router.resolve({
        path: "/EditCreditProduct",
        query: query
      });
      window.open(routeData.href, "_blank");
    },
    searchData(searchInfo) {
      console.log(`searchData == ${JSON.stringify(searchInfo)}`);
      this.searchKey = searchInfo.searchKey;
      this.startDate = searchInfo.startDate;
      this.endDate = searchInfo.endDate;
      this.searchValue = searchInfo.keyword;
      this.loadData();
    },
    async printData(item) {
      // console.log(`printData item === ${JSON.stringify(item)}`);
      this.rowItemInfo = item;
      const results = await this.fetchCreditProductInfo({
        caseId: item.caseId
      });
      if (results && results.length > 0) {
        this.editedItem = results[0];
        if (!this.editedItem.platform) {
          this.editedItem.platform = 0;
        }
        if (this.rowItemInfo.displayId && !this.editedItem.displayId) {
          this.editedItem.displayId = this.rowItemInfo.displayId;
        }
        console.log(`this.editedItem  === ${JSON.stringify(this.editedItem)}`);
        this.toolDialog.visible = true;
      }
    },
    printCreditView(type) {
      if (type === 0) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: this.editedItem.category,

            isPrint: false
          }
        });
        window.open(routeData.href, "_blank");
      } else if (type === 1) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: this.editedItem.category,
            isPrint: false
          }
        });
        window.open(routeData.href, "_blank");
      } else if (type === 2) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: this.editedItem.category,
            isPrint: true
          }
        });
        window.open(routeData.href, "_blank");
      } else if (type === 4) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 4,
            isPrint: true
          }
        });
        window.open(routeData.href, "_blank");
      }
      if (type === 6) {
        // CA列印
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 2,
            isPrint: true,
            platform: this.editedItem.platform
          }
        });
        window.open(routeData.href, "_blank");
      } else if (type === 7) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 7,
            isPrint: true
          }
        });
        window.open(routeData.href, "_blank");
      } else if (type === 8) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 8,
            isPrint: true
          }
        });
        window.open(routeData.href, "_blank");
      } else if (type === 9) {
        const routeData = this.$router.resolve({
          name: "EditCreditProduct",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 4,
            enable: false,
            agentId: this.getUserInfo.userId,
            editIndex: 0
          }
        });
        window.open(routeData.href, "_blank");
      } else if (type === 10) {
        const routeData = this.$router.resolve({
          path: "/CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 6,
            isPrint: false
          }
        });
        window.open(routeData.href, "_blank");
      } else if (type === 11) {
        const routeData = this.$router.resolve({
          path: "/CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 6,
            isPrint: true
          }
        });
        window.open(routeData.href, "_blank");
      } else {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: this.editedItem.category,
            isPrint: false
          }
        });
        window.open(routeData.href, "_blank");
      }
    },
    async toolEvent(index) {
      if (index === 2) {
        this.uploadDialog = true;
        this.toolDialog.visible = false;
      } else if (index === 3) {
        this.uploadFileDialog = true;
        this.toolDialog.visible = false;
      }
    },
    async pageView(item) {
      this.pageDialog.visible = true;
      this.editedItem = item;
      if (!this.editedItem.platform) {
        this.editedItem.platform = 0;
      }
      this.productName = this.editedItem.productName;
      this.carId = this.editedItem.carId;
      // console.log(`printData == ${JSON.stringify(item)}`);
    },
    async uploadData(item) {
      console.log(`uploadData == ${JSON.stringify(item)}`);
      const results = await this.fetchCreditProductInfo({
        caseId: item.caseId
      });
      if (results && results.length > 0) {
        this.editedItem = results[0];
        if (!this.editedItem.platform) {
          this.editedItem.platform = 0;
        }
        this.uploadDialog = true;
      }
    },
    onFinishUpload(result) {
      console.log(`onFinishUpload === ${JSON.stringify(result)}`);
      this.uploadDialog = false;
      this.loadData();
    },
    async uploadFileData(item) {
      console.log(`uploadFileData == ${JSON.stringify(item)}`);
      const results = await this.fetchCreditProductInfo({
        caseId: item.caseId
      });
      if (results && results.length > 0) {
        this.editedItem = results[0];
        if (!this.editedItem.platform) {
          this.editedItem.platform = 0;
        }
        this.uploadDialog = true;
      }
    },
    onFinishFileUpload(result) {
      console.log(`onFinishFileUpload === ${JSON.stringify(result)}`);
      this.uploadFileDialog = false;
      this.loadData();
    },
    closeDialog() {
      this.loading = false;
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      if (!this.editedItem.platform) {
        this.editedItem.platform = 0;
      }
      this.editedIndex = -1;
      this.loadData();
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    createLink(index) {
      if (index === 0) {
        // 商品
        const link = getFinanceUrl(this.getUserInfo.agentId, 1);
        window.open(link, "_blank");
      }
      if (index === 1) {
        // 原融
        let link = getFinanceUrl(this.getUserInfo.agentId, 0);
        link += "&tab=0";
        link += "&platform=0";
        window.open(link, "_blank");
      }
      if (index === 2) {
        // 高踞
        let link = getFinanceUrl(this.getUserInfo.agentId, 2);
        link += "&platform=3";
        window.open(link, "_blank");
      }
      if (index === 4) {
        let link = getFinanceUrl(this.getUserInfo.agentId, 4);
        link += "&platform=1";
        window.open(link, "_blank");
      }
      if (index === 5) {
        let link = getFinanceUrl(this.getUserInfo.agentId, 5);
        link += "&platform=2";
        window.open(link, "_blank");
      }
      if (index === 6) {
        let link = getFinanceUrl(this.getUserInfo.agentId, 6);
        link += "&platform=2";
        window.open(link, "_blank");
      }
      if (index === 7) {
        // 原融-新版
        let link = getFinanceUrl(this.getUserInfo.agentId, 0);
        link += "&tab=1";
        window.open(link, "_blank");
      }
    },
    shareToLine(index) {
      if (index === 0) {
        // 商品
        const link = getFinanceUrl(this.getUserInfo.agentId, 1);
        const line = new LineShare();
        line.share(link);
      }
      if (index === 1) {
        // 原融
        const link = getFinanceUrl(this.getUserInfo.agentId, 0);
        const line = new LineShare();
        line.share(link);
      }
    },
    closeDialogView() {
      this.loanhfcDialog.visible = false;
      this.entrepreneurDialog.visible = false;
    },
    async loadFinanceCountInfo() {
      //取當日
      const date = new Date(),
        y = date.getFullYear(),
        m = date.getMonth();
      const firstDay = customFormatDate(new Date(y, m, 1), "YYYY-MM-DD");
      const lastDay = customFormatDate(new Date(y, m + 1, 0), "YYYY-MM-DD");
      const query = {
        agentId: this.isAdmin
          ? ""
          : this.getUserInfo.agentId
          ? this.getUserInfo.agentId
          : "",
        start: `${firstDay} 00:00:00`,
        end: `${lastDay} 23:59:59`
      };
      console.log(query);

      this.fetchCountLoading = true;
      const res = await this.getFinanceCountInfo(query);
      this.fetchCountLoading = false;
      if (res && res.data) {
        const info = res.data.data;
        this.financeCountInfo.today = info.count;
        this.financeCountInfo.month = info.rangeCount;
      }
    },
    loanhfcEvent(type) {
      // 和潤 面板點擊事件
      console.log(`loanhfcEvent === ${type}`);
      if (type === 9) {
        const routeData = this.$router.resolve({
          path: "/EditCreditProduct",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 4,
            enable: false,
            agentId: this.getUserInfo.userId,
            editIndex: 0
          }
        });
        window.open(routeData.href, "_blank");
      } else if (type === 3) {
        this.loanhfcDialog.visible = false;
        if (!this.editedItem.laonhfcInfo) {
          this.editedItem.laonhfcInfo = new LaonhfcModel();
        }
        if (!this.editedItem.paymentInfo) {
          this.editedItem.paymentInfo = new PaymentInfoModel();
        }
        if (!this.editedItem.caseInsure) {
          this.editedItem.caseInsure = new CaseInsureModel();
        }
      } else if (type === 4) {
        const routeData = this.$router.resolve({
          path: "/CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 4,
            isPrint: true
          }
        });
        window.open(routeData.href, "_blank");
      } else if (type === 10) {
        const routeData = this.$router.resolve({
          path: "/CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 4,
            isPrint: false
          }
        });
        window.open(routeData.href, "_blank");
      } else if (type === 1) {
        const routeData = this.$router.resolve({
          path: "/CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 4,
            caseVersion: 1,
            isPrint: false
          }
        });
        window.open(routeData.href, "_blank");
      } else if (type === 2) {
        const routeData = this.$router.resolve({
          path: "/CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 4,
            caseVersion: 2,
            isPrint: false
          }
        });
        window.open(routeData.href, "_blank");
      }
    },
    caEvent(type) {
      if (type === 1) {
        this.editedItem = new ApplicationModel();
        // const link = getFinanceUrl(this.getUserInfo.agentId, 2);
        // window.open(link, '_blank');
        const query = {
          caseCategory: 2,
          editIndex: -1,
          agentId: this.getUserInfo.agentId,
          platform: this.editedItem.platform //0裕富 3高踞
          // platform: 3 //商品貸編號
        };
        let routeData = this.$router.resolve({
          path: "/EditCreditProduct",
          query: query
        });
        window.open(routeData.href, "_blank");
      } else if (type === 2) {
        const query = {
          caseCategory: 2,
          editIndex: 0,
          caseId: this.editedItem.caseId,
          enable: true,
          agentId: this.getUserInfo.userId,
          platform: this.editedItem.platform,
          isNew: 1,
          isFinance: 1
        };
        // this.$router.push({ path: '/EditCreditProduct', query });
        let routeData = this.$router.resolve({
          path: "/EditCreditProduct",
          query: query
        });
        window.open(routeData.href, "_blank");
      } else if (type === 10) {
        const routeData = this.$router.resolve({
          path: "/CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 2,
            isPrint: true,
            platform: this.editedItem.platform
          }
        });
        window.open(routeData.href, "_blank");
      } else if (type === 11) {
        const routeData = this.$router.resolve({
          path: "/CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 2,
            isPrint: false,
            platform: this.editedItem.platform
          }
        });
        window.open(routeData.href, "_blank");
      }
    },
    handleLoadData() {
      this.loadData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/web/InsureAgentList.vue